import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EnvironmentStrip from '../EnvironmentStrip.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, {
    class: "flex-col w-full",
    style: {"z-index":"0"}
  }, {
    default: _withCtx(() => [
      _createVNode(EnvironmentStrip, { overlay: "" }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})